import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SearchMedioPagoRequest, SaveMedioPagoDto, MedioPago } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class MedioPagoService extends CrudService<MedioPago, number, SaveMedioPagoDto, SearchMedioPagoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'medioPago', sharedFunctions);
  }
  
}
